module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-content"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "model": _vm.form,
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "popper-append-to-body": false,
      "size": "small",
      "filterable": "",
      "collapse-tags": "",
      "placeholder": "请选择类别"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }, [_c('span', {
      staticClass: "check"
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "0.08rem"
      }
    }, [_vm._v(_vm._s(item.label))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    staticStyle: {
      "height": "2rem"
    },
    attrs: {
      "type": "datetimerange",
      "range-separator": "-",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.timeValue),
      callback: function($$v) {
        _vm.timeValue = $$v
      },
      expression: "timeValue"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "refresh",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.firstSearch()
      }
    }
  }, [_vm._v("刷新"), _c('i', {
    staticClass: "el-icon-refresh-right"
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "search",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.firstSearch()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticClass: "deltale",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.deltale()
      }
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('el-button', {
    staticClass: "doexcel",
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.doexcel()
      }
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "loadingPrivate",
    staticStyle: {
      "width": "100%,font-size:0.5rem,margin-bottom:1rem"
    },
    attrs: {
      "max-height": "500",
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "序号ID",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realName",
      "label": "真实姓名",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "电话号码",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tradeAmount",
      "label": "交易金蟾豆数",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tradeStatus",
      "label": "交易状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.tradeStatus == '0') ? _c('span', [_vm._v("提交中")]) : _vm._e(), _vm._v(" "), (scope.row.tradeStatus == '1') ? _c('span', [_vm._v("成功")]) : _vm._e(), _vm._v(" "), (scope.row.tradeStatus == '2') ? _c('span', [_vm._v("失败")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderBody",
      "label": "订单类型",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.orderBody == '2') ? _c('span', [_vm._v("云创")]) : _vm._e(), _vm._v(" "), (scope.row.orderBody == '3') ? _c('span', [_vm._v("金保通")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "predictAmount",
      "label": "应发金额(分)",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actualAmount",
      "label": "实发金额(分)",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "thirdOrderNo",
      "label": "三方订单号",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tradeOrderNo",
      "label": "交易订单号",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.dataFormat(scope.row.createTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endTime",
      "label": "完成时间",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.dataFormat(scope.row.endTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleClick(scope.row)
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isPage) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageNumber,
      "page-size": 15,
      "layout": " prev, pager, next",
      "total": _vm.totalCount
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.firstSearch,
      "update:currentPage": function($event) {
        _vm.pageNumber = $event
      },
      "update:current-page": function($event) {
        _vm.pageNumber = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagNum"
  }, [_vm._v("共" + _vm._s(_vm.pagNum) + "页 （共" + _vm._s(_vm.totalCount) + "条）")])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "订单详情",
      "visible": _vm.dialogVisible,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("应发金额(分):")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.orderDetails.predictAmount))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("个人附加费(分):")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.orderDetails.additionalCharge))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("个人承担个税(分):")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.orderDetails.taxFee))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("个人服务费汇总(个人个税+个人附加费)(分):")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.orderDetails.personServiceFee))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("实发金额(分):")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.orderDetails.actualAmount))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62d338c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/page/messageUpdate/message2.vue
// module id = 3230
// module chunks = 1